module.exports = __webpack_public_path__ + "Mission Icon.a98bcd68.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/landing/Mission Icon.png
// module id = UHCp
// module chunks = 0